import * as React from 'react';
import { AiSummaryModalDesktop } from '../../components/AiSummaryModalDesktop';

export interface IAiSummaryModalDesktopContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AiSummaryModalDesktopContainer = ({
  open,
  onOpenChange,
}: IAiSummaryModalDesktopContainerProps): React.JSX.Element => {
  return <AiSummaryModalDesktop onOpenChange={onOpenChange} open={open} />;
};
